











import { Component, Vue } from "vue-property-decorator";

@Component({
  metaInfo: { title: "Design Clarification Unavailable" },
  components: {},
})
export default class PreviewUnavailablePage extends Vue {}
